
@if (!login) {
  <app-header></app-header>
}
<div class="divContent">
  <router-outlet></router-outlet>
</div>
@if (!login) {
  <app-footer></app-footer>
}
